import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import CustomerTermsContent from "./CustomerTermsContent";

const CustomerTermsAndConditions: React.FC = () => {
  return (
    <LegalPageLayout title="Pheefee User Terms and Conditions" lastUpdated="April 20, 2026">
      <CustomerTermsContent />
    </LegalPageLayout>
  );
};

export default CustomerTermsAndConditions;
